export const TRANSLATIONS_ES = {
  hello: 'Hola',
  welcome: 'Bienvenid@',
  test: 'Prueba',
  nav: {
    home: 'Inicio',
    myClass: 'Mi Curso',
    resources: 'Recursos',
    webinars: 'Seminarios Web',
    bupmode: 'Modo BUP!',
    inbox: 'Bandeja de entrada',
    sendMessage: 'Enviar MODO BUP!',
    archivedCases: 'Casos archivados',
    data: 'Data!',
    profileCard: {
      myAccount: 'PERFIL',
      logOut: 'CERRAR SESIÓN',
    },
    footer: {
      text1: '2021 BRAVEUP',
      text2: '2021 BRAVEUP. Todos los derechos reservados',
    },
    error: {
      errorMesssage:
        'Lo sentimos, no fue posible cargar este contenido, por favor vuelve a intentarlo.',
      buttonError: 'Reintentar',
    },
  },

  pages: {
    profile: {
      title: 'Mi Perfil',
      name: 'Nombre',
      email: 'Correo Electrónico',
      school: 'Establecimiento',
      role: 'Estamento',
      course: 'Curso',
      buttonTextPassword: 'Cambiar contraseña',
      messageDescription1: 'Se ha enviado un mensaje a',
      messageDescription2: 'para restablecer tu contraseña',
    },
    login: {
      welcomeText1: 'Te damos la bienvenida a BRAVE UP!',
      welcomeText2: 'Por favor ingresa tus datos para iniciar sesión',
      emailPlaceHolder: 'micorreo@braveup.com',
      emailLabel: 'Correo Electrónico',
      emailRequiredMessage: 'Email requerido.',
      emailInvalidMessage: 'El email no es valido.',
      passwordLabel: 'Contraseña',
      PasswordRequiredMessage: 'Contraseña requerida.',
      signinButton: 'Iniciar Sesión',
      forgottenPassword: '¿Has olvidado tu contraseña?',
    },
    home: {
      welcomeTitle: 'Hola',
      introText:
        'Somos BRAVE UP! y esta plataforma será nuestro lugar de encuentro a lo largo del año. Aquí encontrarás todo lo necesario para que la convivencia escolar presencial y digital de tu comunidad mejore con la participación de todos y todas. Mientras, despierta tu curiosidad y anímate a descubrir las funciones y contenidos disponibles.',
      imgAlt: 'Imagen Información',
      bupSection: 'MODO BRAVE UP!',
      lastMessages: 'Últimos mensajes recibidos',
      resourceSection: 'ÚLTIMOS RECURSOS',
      dataSection: 'BRAVE UP! DATA',
      dataPanel: {
        button1Text: 'Conoce y habilita los instrumentos de tu establecimiento',
        button2Text: 'Seguimiento últimos resultados de encuestas',
        buttonATPS: 'Conoce los instrumentos de convivencia escolar',
        buttonAnswer: 'Responde el diagnóstico de convivencia escolar',
        resourceButton:
          'Conoce y descarga el material de apoyo para estudiantes',
      },
      errorMessage:
        '   Ocurrió un error al cargar los recursos, por favor vuelve a intentarlo.',
      noResources: 'No hay recursos disponibles',
      noMessage: 'No hay mensajes en tu bandeja de entrada',
    },
    resources: {
      pageName: 'Recursos',
      pageNameText1: 'Recurso:',
      pageNameText2: 'Sin Nombre',
      title: 'Selecciona el área que quieres trabajar:',
      textNoResources: 'No existen recursos',
      textNoLevels: 'No existen niveles',
    },
    webinars: {
      pageName: 'Seminarios web',
      pageName2: 'No existe Seminario',
      introText1:
        'Para conocer más y aprender sobre la convivencia escolar, el mundo digital de tus estudiantes y cómo acompañarlos(as), los(as) invitamos a participar de nuestras charlas web. En este espacio podrás acceder a éstas en vivo e interactuar dejando tus preguntas y comentarios en el chat que estará disponible (solo podrás comentar si estás registrado en Youtube o con tu usuario Gmail). Recuerda que la charla quedará disponible en la plataforma durante dos semanas, por lo que podrás verlas nuevamente si quisieras revisar y profundizar en el contenido de éstas.',
      introText2:
        ' Para conocer más y aprender sobre la convivencia escolar, el mundo digital de tus hijos(as) y cómo acompañarlos(as), los(as) invitamos a participar de nuestras charlas web. En este espacio podrás acceder a éstas en vivo e interactuar dejando tus preguntas y comentarios en el chat que estará disponible (solo podrás comentar si estás registrado en Youtube o con tu usuario Gmail). Si no pudiste conectarte el día y horario en que se llevó a cabo la charla, recuerda que estas quedarán disponibles durante 2 semanas en la plataforma.',
      noWebinarsText:
        ' Aun no se han realizado charlas en tu establecimiento, las fechas de estas serán anunciadas por el encargado de convivencia de tu comunidad. Luego de la transmisión en vivo de la charla, quedarán guardadas en este espacio.',
      titleSatisfactionSurvey: 'Encuesta de Satisfaccion',
      answerHereText: 'Responde Aquí',
      titleDownloadableDoc: 'Documento descargable',
      downloadText: 'Descargalo Aquí',
    },
    modeBup: {
      pageName: 'Modo BUP!',
      notificationHelper: {
        titleHelper: 'Guía para el buen uso',
        bodyHelper: '¿Qué es el MODO BRAVE UP!?',
        bodyHelper2: 'Preguntas Frecuentes',
      },
      send: {
        sendMessageTextComponent: {
          titleEce: '¿QUÉ ES EL MODO BUP!?',
          text1Ece:
            'Es un canal de comunicación directo con el equipo de convivencia escolar, donde de forma anónima o no, profesores, estudiantes y/o apoderados pueden escribir, sobre distintas situaciones de convivencia que suceden entre los miembros de la comunidad escolar, ya sea en el espacio físico o digital. De esta manera se potenciará una comunidad donde todos(as) sean responsables de construir una sana convivencia escolar.',
          text2Ece: 'Aquí encontrarás la',
          text3EceSpan: 'Bandeja de Entrada',
          text4Ece:
            'donde recibirás los mensajes enviados por tu comunidad y la seccion de',
          text5EceSpan: 'Casos Archivados',
          text6Ece:
            'donde podrás guardar los casos que ya fueron resueltos. Te invitamos a que revises ambas secciones:',
          textButton1Ece: 'Bandeja de Entrada',
          textButton2Ece: 'Casos Archivados',
          text7EceSpan:
            'Recuerda que en este espacio podrás conocer y atender en tiempo real las problemáticas y necesidades de tu comunidad.',
          text8Ece:
            'Conocer las experiencias y situaciones desafiantes a las que se enfrentan, posibilita intervenir de manera preventiva, además de dar apoyo y contención.',
          textParent:
            'En este espacio podrás expresar y comunicar situaciones de conflictos, agresiones o malentendidos entre miembros de la comunidad, así también para encontrar apoyo en problemáticas que puedan estar viviendo sus hijos/as.',
          text1Teacher:
            'En este espacio podrás dar a conocer situaciones particulares o grupales de convivencia escolar.',
          text2Teacher:
            'De modo que el equipo de convivencia cuente con información y antecedentes, así como informar necesidades y comunicar preocupaciones relativas al bienestar de los(as) estudiantes. Encontrar apoyo para intervenir efectivamente con sus estudiantes.',
          text1Student:
            'En este espacio podrás encontrar desahogo, contención y apoyo para poder enfrentar de forma positiva la situación expuesta.',
          text2Student:
            'Podrás comunicar situaciones y/o experiencias personales o de otros, de acoso escolar, ciberacoso u otras situaciones que te afecten y no sepas cómo solucionar. También puedes utilizar este espacio para hacer propuestas para mejorar la convivencia dentro de tu comunidad.',
        },
        sendMessageformComponent: {
          notificationMessage: '¡Mensaje Enviado!',
          notificationDescription:
            'Hola, esperamos que te encuentres bien y que la situación que nos cuentas se pueda resolver positivamente. El encargado de convivencia ya cuenta con tu mensaje y en menos de 24 horas te responderá. Muchas gracias por utilizar este espacio y confiar en el modo BUP.',
          notificationErrorMessage:
            'Ocurrió un error inesperado, por favor vuelve a intentarlo.',
          formTitle: '¡Tu voz es importante!',
          formText: 'Hazte oír, estamos aquí para escucharte',
          formTextMessage: 'Debes ingresar un mensaje.',
          formPlaceholder: 'Ej: Tengo un problema con...',
          formCheckBoxText: 'Enviar Anónimamente',
          formButton: 'Enviar',
        },
        collapseTitle: '¿QUÉ ES EL MODO BUP!?',
        collapseText:
          'Es un canal de comunicación directo con el equipo de convivencia escolar, donde de forma anónima o no, profesores, estudiantes y/o apoderados pueden escribir, sobre distintas situaciones de convivencia que suceden entre los miembros de la comunidad escolar, ya sea en el espacio físico o digital. De esta manera se potenciará una comunidad donde todos(as) sean responsables de construir una sana convivencia escolar. Los mensajes enviados por este espacio, son confidenciales, es decir sólo el equipo de convivencia de tu colegio lo podrá ver y te responderá a la brevedad.',
      },
      inbox: {
        breadcrumbText1: 'MODO BUP!',
        breadcrumbText2: 'BANDEJA DE ENTRADA',
        title: 'LISTA DE MENSAJES',
        MessagesListComponent: {
          errorText:
            'Ocurrio un error al cargar los mensajes, por favor vuelve a intentarlo.',
          noMessageText: 'No tienes mesajes',
        },
        MessageElementComponent: {
          tag1: 'ABIERTO',
          tag2: 'CERRADO',
          button1Text1: 'Archivar caso',
          button1Text2: 'Abrir Caso',
          button2Text1: 'Abrir',
          button2Text2: 'Revisar',
          closeMessage: 'Estas seguro que deseas archivar este caso?',
          openMessage: 'Estas seguro que deseas abrir este caso?',
          okText: 'Si',
          cancelText: 'No',
          isOpenMessageClosed: 'Archivar Caso',
          isOpenMessageOpen: 'Abrir Caso',
          isOpenMessageOpen2: 'Open',
          isOpenMessageReview: 'Revisar',
        },
      },
      archivedCases: {
        breadcrumbText1: 'MODO BUP!',
        breadcrumbText2: 'CASOS ARCHIVADOS',
        title: 'casos archivados',
        breadcrumbText3: 'MENSAJE',
      },
      direct: {
        tooltip: 'Volver',
        breadcrumbText1: 'BANDEJA DE ENTRADA',
        breadcrumbText2: 'CASOS ARCHIVADOS',
        breadcrumbText3: 'BANDEJA DE ENTRADA',
        breadcrumbText4: 'MENSAJE',
      },
      chatbox: {
        buttonText: 'Abrir Caso',
        buttonText1: 'Enviar',
        buttonText2: 'Actualizar',
        chatPlaceHolder: 'Envia un mensaje',
        messageRequired: 'Mensaje requerido',
        anonymousCheckBoxState1: 'Seguir enviando anónimamente',
        anonymousCheckBoxState2: 'Enviar Anónimamente',
      },
      messageState: {
        text1: 'Bandeja de entrada',
        text2: 'Casos archivados',
        messageSuccess: 'El mensaje fue movido exitosamente a',
        errorMessage: 'Ocurrio un error, intentalo de nuevo',
      },
    },
    data: {
      components: {
        buttonBackText: 'ATRAS',
        inputFormMessage: 'Campo Requerido',
      },
      title: 'BRAVE UP! DATA',
      linkTextHere: 'aquí.',
      welcomeTextECE:
        'Bienvenido(a) a BRAVE UP! DATA. Somos quienes estamos a cargo de levantar los datos dentro del establecimiento, analizarlos y entregarte recomendaciones que te permitan orientar tu trabajo y planificar de mejor manera las intervenciones en torno a la convivencia escolar presencial y digital. En esta sección encontrarás una serie de herramientas que te permitirán conocer y habilitar los instrumentos en tu establecimiento, responder el diagnóstico, hacer seguimiento y revisar los resultados y recomendaciones que prepararemos para ti.',
      title1ECE: 'Conoce los instrumentos',
      description1ECE:
        'Revisa toda la información que necesitas para comenzar a levantar los datos en tu establecimiento',
      title2ECE: 'Activa y desactiva los instrumentos',
      description2ECE:
        'Es necesario que solicites la activación de cada instrumento que quieras comenzar a aplicar y asegurarte de cerrarlo cuando el proceso haya finalizado. También encontrarás las gráficas de difusión y "Guía de orientación para la toma de datos en clases"',
      title3ECE: 'Responde el diagnóstico',
      description3ECE:
        'Una vez que el diagnóstico esté disponible es importante que tú también participes respondiendo',
      title4ECE: 'Haz seguimiento y revisa los resultados',
      description4ECE:
        'Mientras estés levantando datos, te entregaremos un estado de avance para que puedas hacerle seguimiento. Cuando cierres el proceso, te entregaremos un reporte de resultados y recomendaciones para tu establecimiento',
      welcomeTextStudent:
        '¡Bienvenido(a) a BRAVE UP DATA! Somos quienes estamos a cargo de levantar los datos dentro del establecimiento, analizarlos y entregarles recomendaciones para que puedan mejorar la convivencia escolar presencial y digital. En esta sección podrás conocer los instrumentos que aplicaremos y participar respondiéndolos una vez que estén disponibles.',
      title1Student: 'Conoce los instrumentos',
      description1Student:
        'Conoce los instrumentos que se aplicarán en el establecimiento',
      title2Student: 'Responde',
      description2Student:
        '¡Tu opinión es muy importante para mejorar la convivencia escolar! Participa respondiendo',
      title3Student: 'Responder Sociograma',
      description3Student:
        'Te invitamos a participar y ver como están las relaciones entre los estudiantes que componen tu curso.',
      welcomeTextTeacher:
        '¡Bienvenido(a) a BRAVE UP DATA! Somos quienes estamos a cargo de levantar los datos dentro del establecimiento, analizarlos y entregarles recomendaciones que permitan mejorar la gestión de la convivencia escolar presencial y digital. En esta sección podrás conocer los instrumentos, responder el diagnóstico, y encontrar el material necesario para apoyar la toma de datos de estudiantes.',
      title1Teacher: 'Conoce los instrumentos',
      description1Teacher:
        'Conoce los instrumentos que se podrán aplicar en tu establecimiento',
      title2Teacher: 'Responde el diagnóstico',
      description2Teacher:
        '¡Tu opinión es muy importante para mejorar la convivencia escolar! Participa respondiendo',
      title3Teacher: 'Apoya a tus estudiantes',
      desccription3Teacher:
        'Revisa el material que hemos preparado para que puedas acompañar la aplicación del instrumento y responder todas las dudas que puedan surgir, descargando la "Guía de orientación para la toma de datos en clases".',
      sociogramTeacherTitle: 'Activa el Sociograma',
      sociogramTeacherFinishTitle: 'Finaliza el Sociograma',
      sociogramTeacherDescription:
        'El sociograma a través de la observación y la evaluación de un contexto nos permite reflejar en un gráfico los diferentes vínculos entre los miembros de un grupo. De esta manera, logra dejar en evidencia los grados de influencia y los lazos de preferencia que se presentan en él. Te invitamos a que lo actives en tu curso',
      sociogramMessageActivated:
        'El sociograma para tu curso fue activado exitosamente. Cuando todos tus estudiantes respondan el instrumento, deberás cerrar el proceso haciendo click en el botón "Finalizar sociograma".',
      sociogramMessageCompleted: 'Sociograma finalizado',
      sociogramMessageAlert: 'Activación de sociograma exitosa',
      textPopover: 'Descarga el material aquí',
      instruments: {
        dividerText1: 'INSTRUMENTOS DISPONIBLES',
        dividerText2:
          'CONOCE LOS DETALLES DEL DIAGNÓSTICO DE CONVIVENCIA ESCOLAR',
        dividerText3: 'CONOCE LOS DETALLES DEL SOCIOGRAMA',
        introText:
          'BRAVE UP! DATA ofrece diferentes instrumentos para que tu establecimiento pueda obtener información relevante en torno a la convivencia escolar.',
        diagnosticTitle: 'Diagnóstico de Convivencia Escolar',
        sociogramTitle: 'Sociograma',
        whoAnswerTitle: '¿Quiénes pueden responder?',
        durationTitle: '¿Cuánto dura la encuesta?',
        whatINeedTitle: '¿Qué necesito para empezar?',
        resourcesTitle: '¿Qué recursos dispone BUP! para apoyar este proceso?',
        whatMeasuresInstrumentTitle: '¿Qué mide este instrumento?',
        whatMeasuresInstrumentLink: 'descarga el siguiente documento.',
        whenItEndsTitle: '¿Cuándo finaliza el proceso?',
        startActivationButton: 'Comenzar activación',
        whoCanAnswerTitle: '¿Quiénes pueden responder?',
        howLongTitle: '¿Cuánto dura la encuesta?',
        whatMeasuresTitle: '¿Qué mide?',
        diagnosticDescriptionECE:
          'Busca conocer el estado de la convivencia del establecimiento e identificar sus oportunidades de mejora. Dirigido a toda la comunidad escolar.',
        sociogramDescriptionECE:
          'Busca conocer las relaciones al interior de los cursos para generar acciones que permitan fortalecer los vínculos. Dirigido a estudiantes.',
        whoAnswerDescriptionECE:
          'Estudiantes entre 4º básico y IVº medio. Apoderados(as), docentes y asistentes de la educación de todos los niveles.',
        durationDescriptionECE: '25-30 minutos aproximadamente.',
        whatINeedDescriptionECE:
          'Conocer la cantidad de personas  de cada estamento, coordinar el trabajo con el resto de tus colegas y solicitar la activación.',
        resourcesDescription1ECE:
          'Gráficas de difusión para promocionar el diagnóstico con tu comunidad.',
        resourcesDescription2ECE:
          '"Guía de orientación para la toma de datos en clases"',
        whatMeasuresInstrumentDescriptionECE:
          'Bienestar psicosocial, valoración de las relaciones, gestión de la convivencia, violencia y agresiones en la escuela, entre otros. Para más detalles,',
        whenItEndsDescriptionECE:
          'Debes solicitar el cierre del Diagnóstico y BRAVE UP! DATA comenzará a preparar el Reporte de Resultados que estará disponible en esta misma plataforma.',
        whoCanAnswerDescriptionECE: 'Estudiantes entre 4º básico y IVº medio.',
        durationSociogramDescriptionECE: '25-30 minutos aproximadamente.',
        whatMeasuresDescriptionECE:
          'Las relaciones de simpatía y de tensión que cada estudiante percibe dentro de su curso.',
        diagnosticDescriptionTeacher:
          'Busca conocer el estado de la convivencia del establecimiento e identificar sus oportunidades de mejora. Dirigido a toda la comunidad escolar.',
        sociogramDescriptionTeacher:
          'Busca conocer las relaciones al interior de los cursos para generar acciones que permitan fortalecer los vínculos. Dirigido a toda la comunidad escolar.',
        whoAnswerDescriptionTeacher:
          'Estudiantes entre 4º básico y IVº medio. Apoderados(as), docentes y asistentes de la educación de todos los niveles.',
        durationDescriptionTeacher: '25-30 minutos aproximadamente.',
        resourcesDescription1Teacher:
          'Gráficas de difusión para promocionar el diagnóstico con tu comunidad.',
        resourcesDescription2Teacher:
          '"Guía de orientación para la toma de datos en clases"',
        whatMeasuresInstrumentDescriptionTeacher:
          'Bienestar psicosocial, valoración de las relaciones, gestión de la convivencia, violencia y agresiones en la escuela, entre otros. Para más detalles,',
        whenItEndsDescriptionTeacher:
          'Una vez que toda la comunidad responda, le entregaremos al Equipo de Convivencia un Reporte de Resultados y Recomendaciones.',
        whoCanAnswerDescriptionTeacher:
          'Estudiantes entre 4º básico y IVº medio.',
        durationSociogramDescriptionTeacher: '25-30 minutos aproximadamente.',
        whatMeasuresTeacher:
          'Las relaciones de simpatía y de tensión que cada estudiante percibe dentro de su curso.',
        activeSociogramTitle: 'ACTIVAR SOCIOGRAMA',
        activeSociogramDescription:
          ' Te invitamos a que selecciones a los/as estudiantes de tu curso que realizarán el Sociograma. Te recordamos que los/as estudiantes que NO estén seleccionados/as NO podrán responder el sociograma.',
        activateStudentTableheader1: 'Nombre',
        activateStudentTableheader2: 'Correo electrónico',
        totalStudents: 'Cantidad total de alumnos',
        studentSelected: 'Has seleccionado:',
        studentTag: 'alumnos',
        successMessage1: 'Activación de sociograma exitosa',
        button1: 'Volver a Data',
        modalTitle: '¡Estás a punto activar el sociograma para tu curso!',
        errorMessage: 'Ocurrió un error, por favor intentelo nuevamente',
        sentButton: 'Enviar activación',
        cancelbutton: 'Cancelar',
        confirmMessage: 'Confirmar activación',
        questionMessage: '¿Estás seguro(a) que deseas continuar?',
        diagnosticDescriptionStudent:
          'Está dirigido a toda la comunidad escolar. Busca conocer el estado de la convivencia del establecimiento e identificar sus fortalezas y debilidades para poder mejorar.',
        sociogramDescriptionStudent:
          'Está dirigido a estudiantes. Busca conocer las relaciones que se dan entre compañeros(as) de curso para generar acciones que permitan fortalecer los vínculos',
        whoAnswerDescriptionStudent:
          'Estudiantes entre 4º básico y IVº medio. Apoderados(as), docentes y asistentes de la educación de todos los niveles.',
        durationDescriptionStudent: '25-30 minutos aproximadamente.',
        whatMeasuresInstrumentDescriptionStudent:
          'Bienestar en la escuela, relaciones entre miembros de la comunidad, espacios de participación, situaciones de violencia y agresiones, entre otros.',
        whenItEndsDescriptionStudent:
          'Una vez que toda la comunidad responda, le entregaremos al Equipo de Convivencia un Reporte de Resultados y Recomendaciones.',
        whoCanANswerDescriptionStudent:
          'Estudiantes entre 4º básico y IVº medio.',
        durationSociogramDescriptionStudent: '25-30 minutos aproximadamente.',
        whatMeasuresDescriptionStudent:
          'Las relaciones de amistad y de tensión que cada estudiante percibe dentro de su curso',
      },
      activationSteps: {
        popoverText1: 'Descarga la guía aquí',
        popoverText2: 'Descarga las gráficas aquí',
        dividerTitle: 'PASOS PARA LA ACTIVACIÓN',
        welcomeText:
          'Antes de solicitar la activación, asegúrate de seguir todos los pasos que te recomendamos a continuación para que el levantamiento de datos resulte lo mejor posible.',
        step1Title:
          'Averigua la cantidad exacta de personas que componen cada estamento',
        step1Description:
          'Esto permitirá conocer cuántas respuestas necesitamos alcanzar para obtener datos representativos de estudiantes entre 4º básico y IVº medio, docentes, asistentes de la educación y apoderados(as) del establecimiento. Te pediremos estos datos al activar la encuesta.',
        step2Title: 'Prepara las fechas en las que se tomarán los datos',
        step2Description:
          'Antes de solicitar la activación es importante que programes la toma de datos en tu establecimiento, así te aseguras de alcanzar una amplia participación y que el proceso no demore más que las 2 semanas estimadas.',
        step3Title:
          'Coordina el levantamiento de datos con los(as) profesores(as) jefes',
        step3Description:
          "Recomendamos que los(as) estudiantes respondan el diagnóstico en una hora de clases y con el apoyo de su profesor(a) para responder cualquier duda que surja. Recuerda que puedes descargar la 'Guía de orientación para la toma de datos en clases'.",
        step4Title: 'Difunde en la comunidad',
        step4Description:
          'Hemos diseñado una serie de gráficas para que puedas comunicar y motivar a la comunidad a participar. ¡Están listas para ser descargadas!',
        step5Title: '¡Activa el instrumento!',
        step5Description:
          'Una vez completados los pasos anteriores, estarás listo(a) para solicitar la activación del instrumento. Se activará dentro de 72 horas y estará disponible en esta plataforma durante un máximo de 3 semanas. Te aconsejamos activarla solo cuando tu establecimiento esté listo para su aplicación.',
        step6Title: 'Obtén el reporte de resultados',
        step6Description:
          'Cuando hayan alcanzado las 2 semanas de aplicación y la cantidad mínima de respuestas, debes solicitar el cierre del instrumento para que comencemos a analizar los resultados. De lo contrario, éste se desactivará al finalizar la 3º semana de aplicación. El reporte estará disponible a través de esta plataforma en un máximo de 3 semanas.',
        activationButtonText1: '¿Todo listo?',
        activationButtonText2: 'Comienza la activación',
      },
      startActivation: {
        dividerTitle: 'COMIENZA LA ACTIVACIÓN',
        title: 'DIAGNÓSTICO DE CONVIVENCIA ESCOLAR',
        introText:
          'Lo primero que debes hacer para activar el instrumento es completar el número total de personas que componen cada uno de los estamentos que participarán. Con esto podrás conocer cuál es la cantidad mínima de respuestas que necesitas para que los datos reflejen la realidad de tu comunidad.',
        studentsTitle: 'Estudiantes',
        studentsDescription:
          'Anota el total de alumnos(as) que hay entre 4º básico y IVº medio.',
        parentsTitle: 'Apoderados(as)',
        parentsDescription:
          'Anota el total de familias que hay en el establecimiento',
        teachersTitle: 'Docentes',
        teachersDescription:
          'Anota el total de profesores(as) que hay en el establecimiento',
        assistantsTitle: 'Asist. de la educación',
        assistantsDescription:
          'Anota el total de profesionales que  trabajen directamente con estudiantes, incluido el Equipo de Convivencia.',
        collapseHeader:
          '¡Esta es la cantidad mínima de respuestas que necesitamos en cada estamento!',
        warningSpan: '*¡Advertencia!',
        warningText:
          'Rellena todas las casillas o no podrás avanzar. Si hay un estamento que no participa,entonces escribe un 0 en la casilla correspondiente.',
        activationButtonText: 'Continuar activación',
        activationButtonBoldText: '¡Solo un paso más!',
      },
      termsAndConditions: {
        title: 'LEE Y ACEPTA LAS BASES Y CONDICIONES',
        welcomeText1:
          'Bienvenidos/as a las bases y condiciones de uso de la función BRAVE UP! DATA.',
        welcomeText2:
          'Aceptando las siguientes bases y condiciones de uso nos comunica que está de acuerdo con las siguientes afirmaciones:',
        conditionText1:
          'La participación en este diagnóstico consiste en la aplicación de un instrumento de duración máxima de 45 minutos, estimando un promedio de 20 a 30 minutos. La duración puede variar en función de la edad del/la participante y de su capacidad lectora.',
        conditionText2:
          'La participación de la comunidad en este diagnóstico es completamente voluntaria. Todo miembro del establecimiento tiene el derecho a no aceptar participar o suspender su participación en el momento que lo estimen conveniente, sin mediar explicación alguna y sin consecuencias para él o ella.',
        conditionText3:
          'La información proporcionada por los(as) participantes será confidencial y anónima, es decir, ni su nombre, rut, ni otros datos personales serán publicados ni compartidos. Además, los resultados obtenidos en la toma de datos serán presentados de manera agregada, es decir, no se podrán conocer las respuestas específicas que entregó cada persona.',
        conditionText4:
          'Si bien BRAVE UP! DATA proporciona los insumos necesarios para la difusión y aplicación del instrumento, es de responsabilidad del establecimiento coordinar y compartir la información con la comunidad para asegurar su participación.',
        conditionText5:
          'La construcción del instrumento está basado en un largo proceso de investigación y validación que da sustento teórico y metodológico a las preguntas realizadas. Por este motivo, el establecimiento no puede solicitar cambios ya que estos afectarían su consistencia y coherencia.',
        conditionText6:
          'Luego del levantamiento de datos, BRAVE UP! DATA analizará la información y generará un reporte de resultados que estará disponible en esta misma plataforma en un máximo de tres semanas luego del cierre del instrumento.',
        conditionText7:
          'La información recopilada será entregada al establecimiento con el propósito de mejorar la convivencia escolar dentro de éste. A su vez, podrá ser utilizada con fines científicos, como publicaciones o congresos, así como divulgación en medios impresos y digitales, con el objetivo de aportar con conocimiento aplicado sobre la convivencia escolar presencial y digital, y sus variables. En ningún caso se publicará el nombre del establecimiento a quien responde la información ni se entregarán datos que permitan su identificación.',
        conditionText8:
          ' La información será almacenada por BRAVE UP! por un período de 4 años en los computadores de la organización. A esta información sólo tendrán acceso los(as) profesionales que hayan firmado previamente un acuerdo de confidencialidad respecto al uso de la información, de acuerdo a la Ley 19.628.',
        conditionText9:
          'Toda la información relativa al instrumento y su análisis es de propiedad intelectual exclusiva de BRAVE UP! Se prohíbe la copia, reproducción, distribución o edición total o parcial del mismo sin la autorización expresa de BRAVE UP!. Cualquier copia, reproducción, distribución o edición no autorizada, será sancionada de conformidad a lo dispuesto en la ley Nº 17.736 y sus modificaciones.',
        checkboxText:
          'He leído y acepto las bases y condiciones de BRAVE UP! DATA',
        backButton: 'Volver',
        buttonConfirmText: 'Confirmar',
        buttonActivationText: 'activación',
        modalBackButton: 'Volver a DATA',
        modalButtonDownloadText1: 'Descargar gráficas',
        modalButtonDownloadText2: 'y manual',
        modalTitle: '¡Solicitud enviada con éxito!',
        modalParagraph1: 'La encuesta se activará en un máximo de 72 horas.',
        modalParagraph2:
          'Recuerda descargar las gráficas de difusión, compartir la guía de orientación para la toma de datos en clases con el cuerpo docente y comenzar a preparar todo en tu establecimiento.',
        alertMessage: 'Tu solicitud de activación ya fue enviada',
      },
      activeInstruments: {
        dividerTitle: 'ACTIVA Y DESACTIVA LOS INSTRUMENTOS',
        introText1:
          'Para empezar a levantar los datos, debes solicitar la activación del instrumento que deseas aplicar en tu establecimiento.',
        introText2:
          '* El Diagnóstico de Convivencia Escolar está pensado para implementarse en un período de 2 semanas, plazo en el que debes recordar desactivar la encuesta para que demos inicio al análisis de datos. En caso de que dentro de ese tiempo no se reúna la cantidad mínima de datos necesarios u olvides solicitar el cierre, la encuesta se extenderá automáticamente por 1 semana más.',
        item1Title: 'Diagnóstico de Convivencia Escolar',
        item1Button1: 'Comenzar activación',
        item1Button2Text1: 'Descarga los recursos',
        item1Button2Text2: 'de apoyo',
        item1Button3Text1: 'Solicitar cierre y entrega',
        item1Button3Text2: 'de resultados',
        modal1Title: '¡Estás a punto de cerrar este instrumento!',
        modal1CancelButton: 'Cancelar',
        modal1ConfirmButtonText1: 'Confirmar cierrre y',
        model1ConfirmButtonText2: 'solicitar resultados',
        modal2Title: '¡Solicitud enviada con éxito!',
        modal2ButtonText: 'Volver a DATA',
        modal2Text:
          'Ya estamos preparando tu reporte. En unas semanas te avisaremos cuando esté disponible para ser descargado.',
        modal1Text1:
          'Esto significa que nadie más podrá responderlo y BRAVE UP! DATA comenzará a preparar el reporte de resultados.',
        modal1Text2: '¿Estás seguro(a) que deseas continuar?',
        item2Title: 'Sociograma',
        item2Button1: 'Próximamente',
        messageSuccessSociogram: 'Activación exitosa',
        activatedSociogramMessage: 'Sociograma Activado',
        completedSociogramMessage: 'Sociograma finalizado',
        activationSociogramMessage: 'Comenzar activación',
      },
      confirmSurvey: {
        errorNoInstrumentText1: 'Estimado/a',
        errorNoInstrumentText2: ', aún no hay instrumento disponible.',
        title: 'Diagnóstico de Convivencia Escolar',
        helloText: '¡Hola!',
        introText: 'Antes de comenzar te invitamos a ver el siguiente video:',
        question: '¿Quieres participar?',
        errorFormText: 'Elija al menos una respuesta',
        radioText1: 'Sí, quiero participar.',
        radioText2: 'No, no quiero participar.',
        formButton: 'Siguiente',
        messageSurveySentText1: 'Estimado/a',
        messageSurveySentText2:
          ', tu encuesta ya fue enviada en otra ocasión, gracias por tu tiempo.',
      },
      pendingSurvey: {
        messagePending:
          'Estimado usuario, posees un instrumento pendiente, para reanudar el proceso presiona el boton continuar.',
        continueButton: 'Continuar',
      },
      startSurvey: {
        title: 'Diagnóstico de Convivencia Escolar',
        messageStart:
          'Antes de comenzar te invitamos a ver el siguiente video.',
        askMessage: '¿Quieres participar?',
        yesMessage: 'Yes',
        noMessage: 'No',
        nextMessage: 'Next',
        messageRequired: 'You must select an option',
      },
      desertSurvey: {
        backButtonText: 'Volver a DATA',
        text1: 'Estimado/a',
        text2:
          ', la opinión de toda la comunidad es fundamental para mejorar la convivencia escolar. Si te arrepientes y quisieras volver a responder, te invitamos a hacer click en el diagnóstico y participar!',
        text3: '¡Que tengas un buen día!',
      },
      tracking: {
        title: 'HAZ SEGUIMIENTO Y REVISA LOS RESULTADOS',
        introText:
          'En esta sección puedes revisar la cantidad de miembros de tu comunidad que han respondido los instrumentos que activaste. Si solicitaste el cierre, aquí está disponible un reporte con los principales hallazgos y una serie de recomendaciones elaboradas por el equipo de Educación de BRAVE UP!',
        item1Title: 'Diagnóstico de Convivencia Escolar',
        item1Button1Text: 'Seguimiento',
        item1Button2Text1: 'Reporte de',
        item1Button2Text2: 'resultados',
        item2Title: 'Sociograma',
        item2Button1Text: 'Próximamente',
        item2Button2Text: 'Tablero de resultado',
      },
      advanceStatus: {
        message1: '¡Todavía puedes lograrlo! Refuerza la difusión',
        message2: '¡Vamos bien! Sigue motivando la participación',
        message3: '¡Felicitaciones! Estamento completo',
        dividerTitle: 'ESTADO DE AVANCE',
        introText1:
          'A continuación te contamos cómo está avanzando la toma de datos en tu establecimiento. Éste se actualizará en la medida que recibamos las respuestas de la comunidad y, en base a ella, te recomendamos tomar medidas para aumentar o mantener la participación de los distintos estamentos.',
        introText2:
          'Si todos los estamentos alcanzan o superan el 100% luego de dos semanas desde la activación de la encuesta, podrás solicitar el cierre del proceso haciendo click en el botón debajo de la tabla. De lo contrario, te sugerimos mantenerla abierta una semana más y reforzar la participación. ¡Recuerda que es muy importante alcanzar el mínimo de respuestas!',
        tableHeadText1: 'Total de miembros por estamento',
        tableHeadText2: 'Cantidad mínima de respuestas',
        tableHeadText3: 'Cantidad de respuestas recopiladas',
        tableHeadText4: 'Porcentaje de avance',
        tableHeadText5: 'Recomendación',
        tableRowText1: 'Docentes',
        tableRowText2: 'Asistentes de la educación',
        tableRowText3: 'Apoderados(as)',
        tableRowText4: 'Estudiantes',
        tableRowText5: 'Total',
        requestButtonText1: 'Solicitar cierre y',
        requestButtonText2: 'entrega de resultados',
        modal1Title: '¡Estás a punto de cerrar este instrumento!',
        modal1CancelButton: 'Cancelar',
        modal1ConfrimButtonText1: 'Confirmar cierre',
        modal1ConfrimButtonText2: 'y solicitar resultados',
        modal2Title: '¡Solicitud enviada con éxito!',
        modal2BackButton: 'Volver a DATA',
        modal2Paragraph:
          'Ya estamos preparando tu reporte. En unas semanas te avisaremos cuando esté disponible para ser descargado.',
        modal1Paragraph1:
          'Esto significa que nadie más podrá responderlo y BRAVE UP! DATA comenzará a preparar el reporte de resultados.',
        modal1Paragraph2: '¿Estás seguro(a) que deseas continuar?',
      },
      sociogram: {
        activeSociogramModal: {
          modalTitle:
            '¡Estás a punto de crear un sociograma en tu organización!',
          modalBody: '¿Estás seguro(a) que deseas continuar?',
          modalButton1: 'Cancelar',
          modalButton2: 'Comenzar Activación',
          errorMessageModal: 'Ocurrió un error, por favor intente nuevamente!',
          messageSuccess: 'Activación de sociograma exitosa',
        },
        finishSociogramModal: {
          buttonModalText: 'Finalizar sociograma',
          modalTitle: '¡Estás a punto finalizar el sociograma!',
          modalBody: '¿Estás seguro(a) que deseas continuar?',
          modalButton1: 'Cancelar',
          modalButton2: 'Confirmar',
          errorMessageModal: 'Ocurrió un error, por favor intente nuevamente!',
          messageSuccess: 'Finalización de sociograma exitosa',
        },
      },
      dashBoardSociogram: {
        title: 'Resultado Clima Socioemocional',
        buttonText: 'VER MÁS',
        courseTitle: 'Resultado Sociograma',
        tableTitle: 'Estudiantes',
        toolTitle: 'Herramientas',
        toolSubTitle: 'Grupos de trabajo',
        graphTitle: 'Descarga las Redes de Conviviencias',
        workingMessage:
          'Una vez terminado el sociograma se procesaran los datos y podrás revisarlos aquí.',
        group2Text: 'GRUPOS DE 2',
        group3Text: 'GRUPOS DE 3',
        group4Text: 'GRUPOS DE 4',
        tableHeader1: 'Nombre',
        tableHeader2: 'Email',
        tableHeader3: 'Sexo',
        tableHeader4: 'Popularidad',
        tableHeader5: 'Conflictividad',
        level1: 'Muy alta',
        level2: 'Alta',
        level3: 'Media',
        level4: 'Baja',
        level5: 'Muy baja',
        level6: 'Nula',
      },
      answerSociogram: {
        title: 'SOCIOGRAMA',
        sociogramDescription1:
          'Somos el equipo BRAVE UP! y queremos ayudar a mejorar la convivencia escolar y las relaciones dentro de tu comunidad. Para eso te invitamos a responder las siguientes preguntas y contarnos quiénes son tus amigos(as), con quiénes te gusta trabajar y cómo te sientes en tu escuela.',
        sociogramDescription2:
          '  No existen respuestas buenas o malas, sólo queremos saber sobre ti y si hay algún problema entre tus compañeros(as) de clase en el que podamos ayudar. Por eso, tu participación es muy importante, ya que le permitirá al equipo de orientación saber cómo puede mejorar las relaciones entre todos(as). Responder te tomará solo 15 minutos.',
        sociogramDescription3:
          '¡Participa y construyamos juntos(as) una mejor comunidad escolar!',
        buttonText: 'COMENZAR EL SOCIOGRAMA',
        buttonText2: 'SIGUIENTE',
        noSociogramText: 'No hay sociograma disponible.',
        warningMessage: 'Recuerda revisar tus respuestas antes de continuar',
        noQuestions: 'No existen preguntas disponibles',
        answeredSociogram: 'Sociograma respondido',
      },
    },
  },
};
